import types from './actionTypes';

export const requestRestaurants = () => ({
    type: types.REQUEST_RESTAURANTS,
});

export const setRestaurants = restaurants => ({
    type: types.SET_RESTAURANTS,
    payload: {
        restaurants,
    },
});

export const toggleRestaurantSelected = id => ({
    type: types.TOGGLE_RESTAURANT_SELECTED,
    payload: {
        id,
    },
});

export const toggleAllRestaurantsSelected = selected => ({
    type: types.TOGGLE_ALL_RESTAURANTS_SELECTED,
    payload: {
        selected,
    },
});

export const toggleRestaurantFavourite = id => ({
    type: types.TOGGLE_RESTAURANT_FAVOURITE,
    payload: {
        id,
    },
});

export const checkSelectedRestaurants = () => ({
    type: types.CHECK_SELECTED_RESTAURANTS,
});

export const loadRestaurantsSettings = () => ({
    type: types.RESTAURANTS_SETTINGS_LOAD,
});

export const saveRestaurantsSettings = () => ({
    type: types.RESTAURANTS_SETTINGS_SAVE,
});

export const setSelected = selected => ({
    type: types.SET_SELECTED,
    payload: {
        selected,
    },
});

export const setFavourite = favourite => ({
    type: types.SET_FAVOURITE,
    payload: {
        favourite,
    },
});
